import React from "react"
import StrapiMedia from "../strapi-media"

const Testimonial = ({ data, title, reverse, contentClass }) => {
  if (!data) return <div></div>
  const { content, author, image } = data?.attributes

  return (
    <section className="max-w-screen-2xl w-full px-7 2xl:px-0 mx-auto">
      <div
        className={`lg:w-auto max-w-screen-xl w-full mx-auto ${
          !title ? "lg:pt-[117px] lg:pb-[131px]" : "lg:pt-10"
        } pt-10 flex flex-wrap ${
          reverse ? "lg:flex-row-reverse" : "lg:flex-row"
        } items-center`}
      >
        {title ? <div className="border-t w-full py-10"></div> : ""}
        <div
          className={
            contentClass ? contentClass : "lg:max-w-lg xl:max-w-screen-md"
          }
        >
          <p className="font-bold max-w-sm tracking-[1.8px]">{title}</p>
          <p className="font-cardo leading-[38px]">
            “<br />
            {content}”
          </p>
          <p className="font-montserrat--18 font-bold mt-12">{author}</p>
        </div>
        <div className="mx-auto mt-8 md:mt-0">
          <StrapiMedia image={image} width={273} />
        </div>
      </div>
    </section>
  )
}

export default Testimonial
